import React, { Fragment } from "react";
import AlertTimeOut from "views/administración/home/AlertTimeOut";
import SistemaContableShell from "./components/SistemaContableShell";
import useSistemaContable from "./hooks/useSistemaContable";

const SistemaContable = () => {
  const { currentResource, menuSections, selectResource, title } = useSistemaContable();

  return (
    <Fragment>
      <AlertTimeOut percentageWarnigTimeOut={25} />
      <SistemaContableShell
        currentResource={currentResource}
        menuSections={menuSections}
        selectResource={selectResource}
        title={title}
      />
    </Fragment>
  );
};

export default SistemaContable;
